import { useContext } from "react";
import { animated, useSpring } from "@react-spring/web";
import { AppStateContext } from "../../state/AppProvider";

import { AnswerIcon } from "./AnswerIcon";

const TOOL_LABELS: Record<string, { label: string; icon: string }> = {
    azure_ai_search: { label: "Searching knowledge base", icon: "manage_search" },
    hibob_get_timeoff_balance: { label: "Checking leave balance", icon: "calendar_clock" },
    hibob_get_whos_out: { label: "Checking who's out", icon: "travel" },
    hibob_employee_search: { label: "Searching for employees", icon: "people" },
    hibob_get_my_goals: { label: "Checking goals", icon: "target" },
    hibob_get_goals_by_category: { label: "Checking goals", icon: "target" },
    hibob_get_goal_details: { label: "Checking goal details", icon: "target" }
};

interface Props {
    activeTool?: string | null;
}

export const AnswerLoading = ({ activeTool }: Props) => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });
    const appStateContext = useContext(AppStateContext);

    return (
        <div className="w-full">
            <div className={"py-[18px] px-4 text-base m-auto " + (appStateContext?.state.isChatHistoryOpen ? "" : "lg:pl-16")}>
                <div className="mx-auto flex flex-1 text-base gap-4 lg:gap-6 lg:max-w-3xl">
                    <div className="flex-shrink-0 flex flex-col relative items-end">
                        <div>
                            <div className="pt-0">
                                <div className="outline outline-2 outline-eq-green circle-icon flex h-9 w-9 items-center justify-center overflow-hidden rounded-full">
                                    <div className="relative p-1 rounded-sm flex items-center justify-center h-8 w-8 text-[#000000]">
                                        <AnswerIcon />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative flex w-full min-w-0 flex-col">
                        <div className="flex-col gap-1 lg:gap-3">
                            <div className="flex flex-grow flex-col max-w-full">
                                <div className="flex flex-col gap-1 lg:gap-3">
                                    <div className="flex flex-grow flex-col max-w-full">
                                        <div className="min-h-[20px] text-message flex flex-col whitespace-pre-wrap break-words w-full items-end overflow-x-auto gap-2">
                                            <div className="flex w-full flex-col gap-1 first:pt-[3px]">
                                                <div className="w-full break-words">
                                                    <animated.div style={{ ...animatedStyles }}>
                                                        {activeTool ? (
                                                            <p className="flex items-center gap-1.5 text-eq-grey">
                                                                <span className="material-symbols-outlined text-[1rem]">
                                                                    {TOOL_LABELS[activeTool]?.icon ?? "settings"}
                                                                </span>
                                                                {TOOL_LABELS[activeTool]?.label ?? activeTool}
                                                                <span className="loading-dots" />
                                                            </p>
                                                        ) : (
                                                            <p className="">
                                                                Thinking
                                                                <span className="loading-dots" />
                                                            </p>
                                                        )}
                                                    </animated.div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
